import React, { useEffect, useState } from 'react';
import { FcGoogle } from 'react-icons/fc';
import { startOauth2 } from '../../../lib/api/auth';

const providerIcons = {
  google: FcGoogle
};

const AUTH_METHODS_PATH = '/api/collections/users/auth-methods';

/**
 * SSO entry buttons — LIVE against PocketBase (auth-full-spec §0/§4).
 * Providers render ONLY what PB's auth-methods advertises (today: google);
 * if the endpoint fails or advertises nothing, the buttons render nothing
 * (no mock fallback). The click starts the real hand-rolled PKCE dance in
 * lib/api/auth.js startOauth2 — no provider list is ever hardcoded here.
 */
function OAuthButtons() {
  const [providers, setProviders] = useState([]);

  useEffect(() => {
    let cancelled = false;
    // auth-methods is a plain GET returning {password, oauth2, mfa, otp};
    // an empty/unparseable body or a failure means "render nothing", never a
    // mock fallback.
    fetch(AUTH_METHODS_PATH)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (cancelled) return;
        setProviders(data?.oauth2?.providers || []);
      })
      .catch(() => {
        if (!cancelled) setProviders([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!providers.length) return null;

  return (
    <>
      <div className="oauth-divider" role="separator">
        <span>or continue with</span>
      </div>
      <div className="oauth-buttons">
        {providers.map((provider) => {
          const Icon = providerIcons[provider.name];
          return (
            <button
              className="oauth-button"
              key={provider.name}
              onClick={() => {
                // startOauth2 redirects on success; a failure here (auth-methods
                // flaked between render and click) must not be an unhandled
                // rejection — the buttons simply do nothing in that case.
                startOauth2(provider.name).catch(() => {});
              }}
              type="button"
            >
              {Icon && <Icon aria-hidden="true" />}
              Continue with {provider.displayName || provider.name}
            </button>
          );
        })}
      </div>
    </>
  );
}

export default OAuthButtons;
